module.exports = __webpack_public_path__ + "img/asanmobile4.ac1d2637.png";